import React, { Component } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import './index.css';
import AuthService from '../../components/AuthService';
import { createBrowserHistory } from 'history';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import 'moment/locale/ru';
import locale from 'antd/es/date-picker/locale/ru_RU';
import {
  Form,
  Input,
  Select,
  Checkbox,
  Button,
  DatePicker,
  message
} from 'antd';
import InputPhone from "./input-phone";

const history = createBrowserHistory();


const { Option } = Select;

class Signup extends Component {
  formRef = React.createRef();

  state = {
    email: "",
    password: "",
    confirmDirty: false,
    autoCompleteResult: [],
    region: [],
    city: [],
    gender: [],
    utypes: [],
    regionID: 0,
    recaptchaSite: ""
  }

  captcha = undefined;

  static defaultProps = {
    auth: new AuthService()
  };
  // static getDerivedStateFromProps(props, state) {
  componentWillMount() {
    const { auth } = this.props

    auth.fetch('/api/recaptcha/site').then(res => {
      if (res && res.data) {
        this.setState({ recaptchaSite: res.data });
      }
    });

    auth.fetch('/api/query/region?s-name').then(res => {
      if (res && res.data) {
        this.setState({ region: res.data });
      }
    });

    auth.fetch('/api/query/city?s-name').then(res => {
      if (res && res.data) {
        this.setState({ city: res.data });
      }
    });

    auth.fetch('/api/query/gender?s-name=desc').then(res => {
      if (res && res.data) {
        this.setState({ gender: res.data });
      }
    });

    auth.fetch('/api/query/utypes?s-name=desc').then(res => {
      if (res && res.data) {
        this.setState({ utypes: res.data });
      }
    });
    // return null
  }
  // componentDidMount() {
  //   this.formRef.current.setFieldsValue({
  //     username: 'Bamboo',
  //   });
  // }
  handleRegionChange = (value) => {
    this.setState({
      regionID: value,
    });
    this.formRef.current.setFieldsValue({
      cityID: null,
    });
  };

  handleSubmit = (values) => {
    // e.preventDefault();
    // this.formRef.current.validateFieldsAndScroll((err, values) => {
    //   if (!err) {
    //     e.preventDefault();
    // console.log(values);
    this.props.auth.signup(values)
      .then(res => {
        if (!res.status) {
          if (this.captcha) {
            this.captcha.reset();
          }
          //Валидация (подумать как сделать универсально)
          //Чистим ошибки предыдущей валидации
          this.formRef.current.setFieldsValue(this.formRef.current.getFieldsValue());
          //Показываем новые ошибки
          if (res.invalid && res.invalid.errors) {
            var object = res.invalid.errors
            for (const key in object) {
              if (object.hasOwnProperty(key)) {
                const element = object[key];
                if (element && element.length) {
                  var valData = [];
                  valData.push({
                    name: key,
                    errors: [element[0].message],
                    value: (element[0].value) ? element[0].value : ""
                  })
                  this.formRef.current.setFields(valData);
                }
              }
            }
          }
          message.error(res.message);
        } else {
          this.props.auth.redirect(res);
          // history.replace('/app');
          // history.go(0);
        }
      })
      .catch(err => {
        if (this.captcha) {
          this.captcha.reset();
        }
        // message.error(err);
        console.log(err)
      })
    //     return false;
    //   }
    // });
  };

  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  render() {
    // const { getFieldDecorator } = this.formRef.current;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };
    // const prefixSelector = getFieldDecorator('prefix', {
    //   initialValue: '7',
    // })(
    //   <Select style={{ width: 70 }}>
    //     <Option value="7">+7</Option>
    //   </Select>,
    // );

    var context = this;
    const region = this.state.region.map((d) => <Option key={d.ID}>{d.name}</Option>);
    const city = this.state.city.filter((d) => d.regionID == context.state.regionID).map((d) => <Option key={d.ID}>{d.name}</Option>);
    const gender = this.state.gender.map((d) => <Option key={d.ID}>{d.name}</Option>);
    const utypes = this.state.utypes.map((d) => <Option key={d.ID}>{d.name}</Option>);
    return (
      <div style={{
        height: "calc(100vh - 12px)",
        backgroundColor: (this.props.mobile) ? "white" : "#f5f5f5",
        margin: "5px",
        borderRadius: "5px"
      }}>

        <div className="register-form" style={{paddingBottom: "0px", textAlign: "center", maxWidth: (this.props.mobile) ? "300px" : "600px"}}>
          <a href="/">
            <img src="/resources/logo.svg" alt="Logo" />
          </a>
        </div>

        <Form ref={this.formRef} name="register" {...formItemLayout}
          onFinish={this.handleSubmit}
          onFinishFailed={({ errorFields }) => {
            this.formRef.current.scrollToField(errorFields[0].name);
          }}
          className="register-form"
          style={{ maxWidth: (this.props.mobile) ? "300px" : "600px", paddingTop: "5px" }}
          
          initialValues={{
            genderID: '1',
            utypeID: '1',
            tipTelefonaID: '1',
          }}
        >
          <div style={{
            backgroundColor: "white",
            padding: (this.props.mobile) ? "0px" : "25px",
            boxShadow: "1px 1px 8px 0px rgba(34, 60, 80, 0.2)",
            borderRadius: "5px"
          }}>
            <Form.Item label="E-mail"
              name="email"
              rules={[
                {
                  type: 'email',
                  message: 'Введен неверный E-mail!',
                },
                {
                  required: true,
                  message: 'Пожалуйста, введите свой E-mail!',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Пароль" hasFeedback
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Пожалуйста, введите пароль не меньше 8 символов!',
                },
                {
                  min: 8,
                  message: 'Пожалуйста, введите пароль не меньше 8 символов!',
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item label="Повторите пароль" hasFeedback
              name="confirm"
              dependencies={['password']}
              rules={[
                {
                  required: true,
                  message: 'Пожалуйста, повторите ваш пароль!',
                },
                {
                  min: 8,
                  message: 'Пожалуйста, повторите ваш пароль!',
                },
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject('Пароли не совпадают!');
                  },
                }),
              ]}
            >
              <Input.Password onBlur={this.handleConfirmBlur} />
            </Form.Item>

            <Form.Item label={"Фамилия"}
              name="lastname"
              rules={[{ required: true, message: 'Пожалуйста, введите фамилию!' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item label={"Имя"}
              name="firstname"
              rules={[{ required: true, message: 'Пожалуйста, введите имя!' }]}
            >
              <Input />
            </Form.Item>
            {/* <Form.Item label={"Отчество"}
              name="patronymic"
            >
              <Input />
            </Form.Item>
            <Form.Item label={"Дата рождения"}
              name="birthday"
              rules={[{ required: true, message: 'Пожалуйста, введите дату рождения!' }]}
            >
              <DatePicker format="DD.MM.YYYY" locale={locale} />
            </Form.Item>

            <Form.Item label="Пол"
              name="genderID"
              rules={[{ required: true, message: 'Пожалуйста, укажите пол!' }]}
            >
              <Select>
                {gender}
              </Select>
            </Form.Item> */}

            <Form.Item label="Роль"
              name="utypeID"
              rules={[{ required: true, message: 'Пожалуйста, укажите роль!' }]}
            >
              <Select>
                {utypes}
              </Select>
            </Form.Item>

            <Form.Item label={"Телефон"}
              name="phone"
              rules={[
                { required: true, message: 'Пожалуйста, введите телефон!' },
                { pattern: /\d{11,}/g, message: 'Пожалуйста, введите телефон!' }
              ]}
            >
              <InputPhone />
            </Form.Item>

            <Form.Item {...tailFormItemLayout}
              name="captcha"
              rules={[{ required: true, message: 'Мы должны убедиться, что вы человек!' }]}
            >
              <ReCAPTCHA
                ref={e => (this.captcha = e)}
                sitekey={this.state.recaptchaSite}
              />
            </Form.Item>
            <Form.Item {...tailFormItemLayout}
              name="agreement"
              valuePropName="checked"
              rules={[{
                validator: (_, value) => value ? Promise.resolve() : Promise.reject('Вы должны согласиться с условиями!')
              }]}
            >

              <Checkbox>
                Я прочитал(а) <a href="/agrement">соглашение</a>
              </Checkbox>

            </Form.Item>
            <Form.Item {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit">
                Регистрация
          </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    );
  }
}

// const Signup = Form.create({ name: 'register' })(RegistrationForm);
export default Signup;